<div class="priceRow" [class.selected]="quantity > 0">
  <div class="priceRowText">
    <div class="priceRowLabel"><ng-content select="[rowLabel]"></ng-content></div>
    <div class="priceRowPrice"><ng-content select="[rowPrice]"></ng-content></div>
    <div class="priceRowNotes"><ng-content select="[rowNote]"></ng-content></div>
  </div>
  @if (!locked) {
    <app-quantity-stepper [quantity]="quantity" (decrement)="decrement.emit()" (increment)="increment.emit()"></app-quantity-stepper>
  }
</div>
